export function AccessDeniedPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', padding: '20px' }}>
      <div style={{ textAlign: 'center', maxWidth: 600 }}>
        <h1 style={{ fontSize: '2.5em', marginBottom: '16px', color: 'var(--text)' }}>⛔</h1>
        <h2 style={{ marginBottom: '16px' }}>Нет доступа</h2>
        <p style={{ color: 'var(--muted)', marginBottom: '24px' }}>
          Вы авторизованы, но у вас нет прав для доступа к этому приложению.
          <br />
          Для доступа необходима группа <strong>analyses-norms-admin</strong>.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button onClick={() => window.location.href = '/'}>
            На главную
          </button>
          <button 
            className="secondary" 
            onClick={() => {
              const runtimeEnv: any = (globalThis as any).window?.__ENV || {};
              const API_BASE = (runtimeEnv.API_BASE || process.env.VITE_API_BASE || process.env.API_BASE || '').replace(/\/$/, '');
              window.location.href = `${API_BASE}/api/v1/login?return_url=${encodeURIComponent(window.location.origin)}`;
            }}
          >
            Войти снова
          </button>
        </div>
      </div>
    </div>
  );
}

